// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

import tabbing from './modules/tabbing';
import skip from './modules/skip';
import nav from './modules/nav';
import dropdowns from './modules/dropdowns';
import filters from './modules/filters';
import videos from './modules/videos';
import animtext from './modules/animtext';
import accordion from './modules/accordion';
import projectsView from './modules/projects-view';
import projectsMap from './modules/projects-map';
import heroVideo from './modules/hero-video';
import carousel from './modules/carousel';

carousel();
heroVideo();
tabbing();
skip();
nav();
dropdowns();
filters();
videos();
accordion();
projectsView.init();
projectsMap.init();

const rootEL = document.documentElement;
rootEL.classList.remove('no-js');

// document.addEventListener('DOMContentLoaded', function(e) {
//   document.body.classList.remove('page-is-loading');
// });

window.addEventListener('load', function(e) {
  document.body.classList.remove('page-is-loading');
  animtext();
});

